import { render, staticRenderFns } from "./JuridictionFooter.vue?vue&type=template&id=d9ebc4ca&scoped=true&"
import script from "./JuridictionFooter.vue?vue&type=script&lang=js&"
export * from "./JuridictionFooter.vue?vue&type=script&lang=js&"
import style0 from "./JuridictionFooter.vue?vue&type=style&index=0&id=d9ebc4ca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ebc4ca",
  null
  
)

export default component.exports